var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg18A9C(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "atom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5006 17.9999C19.5006 18.8283 18.829 19.4999 18.0006 19.4999C17.1722 19.4999 16.5006 18.8283 16.5006 17.9999C16.5006 17.1714 17.1722 16.4999 18.0006 16.4999C18.829 16.4999 19.5006 17.1714 19.5006 17.9999ZM30.3004 30.3004C33.3604 27.2554 30.3304 19.2604 23.5504 12.4504C16.7404 5.67044 8.74544 2.64044 5.70044 5.70044C2.64044 8.74544 5.67044 16.7404 12.4504 23.5504C19.2604 30.3304 27.2554 33.3604 30.3004 30.3004ZM23.5504 23.5504C30.3304 16.7404 33.3604 8.74544 30.3004 5.70044C27.2554 2.64044 19.2604 5.67044 12.4504 12.4504C5.67044 19.2604 2.64044 27.2554 5.70044 30.3004C8.74544 33.3604 16.7404 30.3304 23.5504 23.5504Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18A9C);
export default __webpack_public_path__ + "static/media/18a9c.359f6cfef104494954e18a54978b3296.svg";
export { ForwardRef as ReactComponent };